import Make from './../components/MakeSection/Make';
import ServicesSection from '../components/ServicesSection/ServicesSection';
import History from '../components/HistorySection/History';
import HeroSection from '../components/HeroSection/HeroSection';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const About = () => {
  const seo = usePageSEO('about');

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <HeroSection page="AboutPage" showRecentWork={false} showMoreButton={false} />
      <History pageKey="AboutPage" />
      <ServicesSection page="AboutPage" />
      <Make pageKey="aboutPage" />
    </>
  );
};

export default About;